import { createTrackerOptions } from '@/helpers/common';

export const INSURER_MIN_AGE = 17;
export const EMPLOYMENT_STATUS_BUSINESS = ['E', 'S', 'F', 'D', 'P', 'G', 'C'];
export const VEHICLE_TYPE_OF_USE_REQUIRED_DRIVERS = [4, 5, 6];
export const DRIVERS_MAX_QTY = 5;
export const DRIVER_LICENCE_YEARS_HELD = {
  0: 'Less than 1 Year',
  1: '1 Year ',
  2: '2 Years ',
  3: '3 Years ',
  4: '4 Years ',
  5: '5 Years ',
  6: '6 Years ',
  7: '7 Years ',
  8: '8 Years ',
  9: '9 Years ',
  10: '10 Years ',
  11: '11 Years ',
  12: '12 Years',
  13: '13 Years',
  14: '14 Years',
  15: '15 Years',
  16: '16 Years',
  17: '17 Years',
  18: '18 Years',
  19: '19 Years',
  20: '20 Years or more',
};

export const DRIVER_LICENCE_MONTHS_HELD = {
  0: 'Less than 1 Month',
  1: '1 Month',
  2: '2 Months',
  3: '3 Months',
  4: '4 Months',
  5: '5 Months',
  6: '6 Months',
  7: '7 Months',
  8: '8 Months',
  9: '9 Months',
  10: '10 Months',
  11: '11 Months',
};

export const CLAIMS_MAX_QTY = 5;
export const CONVICTIONS_MAX_QTY = 5;
export const DRIVER_TYPE_OF_DRIVING_UK = [1, 2, 3];
export const DRIVER_CLAIM_CAUSE_OF_DESCRIPTION_FAVORITES = ['A', 'W', 'T'];
export const DRIVER_CLAIM_CAUSE_OF_DESCRIPTION = {
  A: 'Accident',
  F: 'Fire',
  O: 'Storm Damage',
  T: 'Theft',
  W: 'Windscreen/Glass',
  V: 'Vandalism',
};

export const VEHICLE_TRANSMISSION_TYPES = {
  M: 'Manual',
  A: 'Automatic',
};

export const DRIVER_TYPE_OF_DRIVING = {
  1: 'UK Full',
  2: 'UK Provisional',
  3: 'UK Automatic',
  4: 'EU Full',
  5: 'EU Provisional',
  6: 'Other European',
  7: 'International',
};

export const VEHICLE_GREY_OR_IMPORT = {
  N: 'No',
  Y: 'European Import UK Spec',
  NU: 'European Import Non-UK Spec',
  J: 'Japanese Import',
  U: 'US Import',
};

export const DRIVER_CLAIM_AT_FAULT = {
  C: 'Our Driver',
  O: 'Other Party',
  B: 'Both Parties',
};

export const DRIVER_CLAIM_TYPE_THEFT = {
  VC: 'Vehicle and The Contents',
  V: 'Just The Contents of The Vehicle',
};

export const DRIVER_CONVICTION_ALCOHOL_METHOD_TEST = {
  B: 'Breath',
  L: 'Blood',
  U: 'Urine',
};

export const DRIVER_CONVICTION_POINTS_RECEIVED = {
  0: '0 Points',
  1: '1 Point',
  2: '2 Points',
  3: '3 Points',
  4: '4 Points',
  5: '5 Points',
  6: '6 Points',
  7: '7 Points',
  8: '8 Points',
  9: '9 Points',
  10: '10 Points',
  11: '11 Points',
  12: '12 Points',
};

export const DRIVER_CONVICTION_ALCOHOL_LEVEL_REQUIRED_CODES = [
  'DR10',
  'DR20',
  'DR30',
  'DR40',
  'DR50',
];

export const COVER_VOLUNTARY_EXCESS = {
  0: 'None',
  50: '£ 50',
  100: '£ 100',
  150: '£ 150',
  200: '£ 200',
  250: '£ 250',
  300: '£ 300',
  350: '£ 350',
  400: '£ 400',
  450: '£ 450',
  500: '£ 500',
  550: '£ 550',
  600: '£ 600',
  650: '£ 650',
  700: '£ 700',
  750: '£ 750',
  800: '£ 800',
  850: '£ 850',
  900: '£ 900',
  950: '£ 950',
  1000: '£ 1000',
};

export const COVER_TYPE_OF_COVER = {
  1: 'Comprehensive',
  2: 'Third Party, Fire & Theft',
  3: 'Third Party Only',
};

export const COVER_TYPE_OF_COVER_DESCRIPTION = {
  1: "Cover provided if your motorhome's damaged, stolen or written off. You’ll be covered for claims made against you by other people too.",
  2: "If your motorhome's stolen, or damaged by fire, you can claim. You’re also covered for claims made against you by other people.",
  3: 'Cover for claims made against you by other people but there’s no cover for you or your motorhome.',
};

export const OPTIONAL_EXTRAS_OPTIONS = [
  {
    value: 'breakdown',
    trackerValue: 'breakdownCover',
    label: 'Breakdown Cover',
  },
  {
    value: 'lossOfUse',
    trackerValue: 'lossOfUse',
    label: 'Loss of Use',
    infoLabel: 'loss of use',
  },
  {
    value: 'legal',
    trackerValue: 'legalCover',
    label: 'Legal Cover',
  },
  {
    value: 'european',
    trackerValue: 'europeanCover',
    label: 'European Cover',
  },
];

export const VEHICLE_USE = {
  1: 'Social Only',
  2: 'Social & Commuting',
  3: 'Business Use (by The Proposer)',
  4: 'Business Use by You and Spouse/Civil Partner',
  5: 'Business Use for All Drivers',
  6: 'Business Use by Spouse/Civil Partner',
  7: 'Commercial Travelling',
};

export const OPTIONAL_EXTRAS_TRACKER_OPTIONS = createTrackerOptions(OPTIONAL_EXTRAS_OPTIONS);

export const DRIVER_MARITAL_STATUS = {
  M: 'Married',
  S: 'Single',
  D: 'Divorced',
  W: 'Widowed',
  C: 'Common law',
  V: 'Civil partnership',
  T: 'Separated',
};

export const ADDITIONAL_RELATIONSHIP_PROPOSER = {
  S: 'Spouse',
  P: 'Parent',
  O: 'Son or Daughter',
  I: 'Brother or Sister',
  C: 'Common Law Spouse',
  V: 'Civil Partner',
  OF: 'Other Family Member',
  B: 'Business Partner',
  EE: 'Employee',
  ER: 'Employer',
  N: 'None',
};

export const MAKE_TITLE = 'What is the base vehicle manufacturer?';
export const HELP_TEXT = 'This may differ from the motorhome manufacturer/converter (e.g Swift, Autotrail, Elddis) which you can enter in a later question.';
export const MODEL_TITLE = 'What is the base vehicle model?';
export const MODEL_PLACEHOLDER = 'e.g. Transporter, Transit, Sprinter, Trafic';
export const ENGINE_SIZE_PLACEHOLDER = 'Please select engine size and type';

export const CAUSE_OF_DESCRIPTION_ACCIDENT = 'A';
export const TYPE_THEFT_VEHICLE_CONTENTS = 'VC';
export const TYPE_THEFT_CONTENTS_OF_THE_VEHICLE = 'V';
export const CLAIM_SETTLED = true;
